module.exports = __webpack_public_path__ + "img/bg1.3d19811c.jpg";